import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../lib/firebase";
import { useAuth } from "../../state/AuthContext";
import { Button } from "./Button";
import "./common.css";

interface AppBarProps {
  /** Optional center/right slot for page-specific actions. */
  actions?: ReactNode;
}

export function AppBar({ actions }: AppBarProps) {
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <header className="appbar">
      <div className="appbar__brand">
        <img className="appbar__logo" src="/aisg-logo.webp" alt="AI Singapore" />
        <span>
          LADP Scoping Assistant{" "}
          <span className="appbar__sub">· AI Singapore</span>
        </span>
      </div>
      <div className="appbar__right">
        {actions}
        {isAdmin && (
          <Button variant="ghost" size="sm" onClick={() => navigate("/admin")}>
            Admin
          </Button>
        )}
        {user?.email && <span className="appbar__user">{user.email}</span>}
        <Button variant="secondary" size="sm" onClick={handleLogout}>
          Log out
        </Button>
      </div>
    </header>
  );
}
